'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useState } from 'react';

export const ReferenceGallery = ({ images }: { images: { url: string; name: string }[] }) => {
  const [imagesSorted, setImagesSorted] = useState<{ url: string; name: string }[]>([]);

  const { isOpen, setIsOpen } = useDisclosure(false);

  const handleOpenGallery = (images: any, index: number) => () => {
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <div className={cn('custom-container', 'grid grid-cols-12 gap-4 lg:gap-8')}>
        {(images ?? []).map((image, index) => {
          return (
            <div
              key={image.name}
              className={cn(
                'relative col-span-12 h-[235px] w-full lg:h-[480px] xl:h-[552px]',
                index === 0 && 'md:col-span-7',
                index === 1 && 'md:col-span-5',
                index === 2 && 'md:col-span-5',
                index === 3 && 'md:col-span-7',
                index === 4 && 'md:col-span-12',
                index === 5 && 'md:col-span-7',
                index === 6 && 'md:col-span-5',
                index === 7 && 'md:col-span-5',
                index === 8 && 'md:col-span-7',
                index === 9 && 'md:col-span-12',
                index === 10 && 'md:col-span-7',
                index === 11 && 'md:col-span-5',
                index === 12 && 'md:col-span-5',
                index === 13 && 'md:col-span-7',
                index === 14 && 'md:col-span-12',
              )}
              onClick={handleOpenGallery(images, index)}
            >
              <Image
                src={image.url}
                alt={resolveImageAlt(image, undefined)}
                fill
                style={{ objectFit: 'cover', objectPosition: 'center' }}
                sizes="100vw"
                className="cursor-pointer"
              />
            </div>
          );
        })}
      </div>
    </>
  );
};
